import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { selectCompanyIndex, selectIsAuthorized } from '../../../redux/selector/system'
import { selectIsFilialCompany } from '../../../redux/selector/company'
import { isClientMonitor } from '../../../helper/clientMonitor'
import { getOwnMenuCardCopyTasksThunk } from '../../../redux/thunk/menuCardCopyTask'
import { setMenuCardUpdatedAt } from '../../../redux/action/menuCardCopyTask'
import { localStorageApi } from '../../../helper/localStorageApi'
import { getLatestFinishedAt, getUnseenTaskIds } from '../../../helper/menuCardCopyTask'

const POLL_INTERVAL_MS = 3 * 60 * 1000
const SHOWN_IDS_STORAGE_KEY = 'menuCardCopyTaskShownIds'

const MenuCardCopyTaskNotificationToast = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isAuthorized = useSelector(selectIsAuthorized)
	const companyIndex = useSelector(selectCompanyIndex)
	const isFilialCompany = useSelector(selectIsFilialCompany)
	const tasks = useSelector(store => store.menuCardCopyTask.tasks)
	const isPollingEnabled = isAuthorized && isFilialCompany && !isClientMonitor()

	useEffect(() => {
		if (!isPollingEnabled) return undefined
		const fetchTasks = () => dispatch(getOwnMenuCardCopyTasksThunk())
		fetchTasks()
		const interval = setInterval(fetchTasks, POLL_INTERVAL_MS)

		return () => clearInterval(interval)
	}, [isPollingEnabled, dispatch])

	useEffect(() => {
		if (!isPollingEnabled || !tasks) return

		const taskIds = tasks.map(task => task.id)
		const shownIdsByCompany = localStorageApi.getItem(SHOWN_IDS_STORAGE_KEY) || {}
		const unseenIds = getUnseenTaskIds(taskIds, shownIdsByCompany[companyIndex] || [])

		if (unseenIds.length > 0) {
			const franchise = tasks.find(task => task.id === unseenIds[0])?.franchise
			toast.info(t('menuCardCopyTaskNotificationToast.text', { name: franchise?.name, companyIndex: franchise?.companyIndex }), { autoClose: false })
			dispatch(setMenuCardUpdatedAt(getLatestFinishedAt(tasks)))
		}

		localStorageApi.setItem(SHOWN_IDS_STORAGE_KEY, { ...shownIdsByCompany, [companyIndex]: taskIds })
	}, [isPollingEnabled, tasks, companyIndex, t, dispatch])

	return null
}

MenuCardCopyTaskNotificationToast.displayName = 'MenuCardCopyTaskNotificationToast'
export default MenuCardCopyTaskNotificationToast
